// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__eWuOZ","main":"Loading_main__W6PFO","loading":"Loading_loading__K7Xi7","spinner":"Loading_spinner__Y9jaO"};